import type {
	KanbanCardInfoSlotProps,
	KanbanCardTableSlotProps,
} from '@/dsComponents/kanban/kanban-cards/types';
import type { WorkerInterview } from '@/modules/companyNeed/types';
import type { HistoryEntry } from '@/modules/companyNeed/types/history';
import type { MoveWorkerActionItem } from '@/modules/companyNeed/types/moveWorker';

export const KANBAN_IS_DRAGGING_KEY = Symbol('need-recruitment-is-dragging');

export enum NeedRecruitmentCardStatus {
	PREQUALIFIED = 'pre-qualified',
	CONTACTED = 'contacted',
	INTERVIEW = 'interview',
	COMPANY_INTERVIEW = 'company-interview',
	COMPANY_PROPOSED = 'company-proposed',
	MISSION_PROPOSED = 'mission-proposed',
	REJECTED = 'rejected',
}

export interface NeedCardFollowing {
	title: string;
	items: NeedCardFollowingItem[];
}

export interface NeedCardFollowingItem {
	icon: string;
	iconColor: string;
	text: string;
	asideText: string;
}

export interface NeedCardProps {
	_id: string;
	firstname: string;
	lastname: string;
	email?: string;
	phone: string;
	lastActionDate?: number;
	following?: NeedCardFollowing;
	contactSlot?: KanbanCardInfoSlotProps;
	planningSlot?: KanbanCardInfoSlotProps;
	interview?: WorkerInterview;
	interviews?: WorkerInterview[];
	companyProposedSlot?: KanbanCardTableSlotProps;
	missionSlot?: KanbanCardTableSlotProps;
	status: NeedRecruitmentCardStatus;
	profilePicture?: string;
	postulatedToJobOffer?: boolean;
	alerts?: NeedRecruitmentCardAlerts[];
	actions?: MoveWorkerActionItem[];
	history?: HistoryEntry[];
}

export enum NeedRecruitmentCardAlerts {
	NOT_DELEGABLE = 'NOT_DELEGABLE',
	INCOMPLETE_REGISTRATION = 'INCOMPLETE_REGISTRATION',
}
